export default __webpack_public_path__ + "static/alina-kupchyk-9d7a7aa8753f5c0d72fe4c56222cf145.png";